import { Routes } from '@angular/router';
import { AuthGuardService } from '@smartflip/authentication';
import { HomeListComponent } from '../views/home-list/home-list.component';
import { HomeComponent } from '../views/home/home.component';
import { LenderFormComponent } from '../views/lender/lender-form/lender-form.component';
import { LoginComponent } from '@smartflip/login';
import { ComparablesComponent } from '@smartflip/feat-comparables';
import { PropertyDetailsComponent } from '../views/property-details/property-details.component';
import { CostDetailsComponent } from '../views/property-details/components/cost-details/cost-details.component';
import { ProfitDetailsComponent } from '../views/property-details/components/profit-details/profit-details.component';
import { GeneralInformationComponent } from '../views/property-details/components/general-information/general-information.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'reports',
    loadChildren: () =>
      import('@smartflip/reporting').then((m) => m.reportingRoutes),
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: 'lender', component: LenderFormComponent }, // May need to be deprecated
      {
        path: 'loan-application',
        loadChildren: () =>
          import('@smartflip/loan-application').then(
            (m) => m.FeaturesLoanApplicationModule,
          ),
      },
      {
        path: 'subscribe',
        loadChildren: () =>
          import('@smartflip/stripe').then((m) => m.StripePaymentModule),
      },
      {
        path: 'export',
        loadChildren: () =>
          import('@smartflip/data-export').then(
            (m) => m.FeaturesFeatDataExportModule,
          ),
      },
      { path: 'properties', component: HomeListComponent },
      {
        path: 'profile',
        loadChildren: () =>
          import('@smartflip/user-profile-view').then(
            (m) => m.UserProfileViewModule,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('@smartflip/feat-app-info').then(
            (m) => m.ApplicationInformationComponent,
          ),
      },
      { path: '', redirectTo: 'properties', pathMatch: 'full' },
    ],
  },

  {
    path: 'property/:propertyId',
    component: PropertyDetailsComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: 'general', component: GeneralInformationComponent },
      { path: 'costs', component: CostDetailsComponent },
      { path: 'analytics', component: ProfitDetailsComponent },
      { path: 'comparables', component: ComparablesComponent },
      { path: '', redirectTo: 'general', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];
